
class TreeSelect {
    constructor(params) {
        this.$tree = params.el
        this.menuData = params.data
        this.init();
    }
    init() {
        const this_ = this
        this.$tree.addEventListener("click", () => {
            if (this.$tree.classList.contains("z-tree-open")) {
                this.closeDrop()
            } else {
                this.openDrop()
            }

            if (this.$tree.getAttribute("data-init") !== "inited") {
                this.creatDrop(this.$tree, this.menuData)
            }
        })

        // 按下 ESC 键关闭
        document.addEventListener('keydown', function (e) {
            if (this_.$tree.classList.contains("z-tree-open") && e.keyCode === 27) {
                this_.closeDrop();
            }
        });

        document.addEventListener("click", this_.outCloseDrop.bind(this_))

        window.addEventListener("scroll", () => {
            const blockid = this.$tree.getAttribute("block-id")
            const $drop = document.querySelector(`.z-select-dropdown[block-id=${blockid}]`)
            if($drop) {
                this.setPos($drop, this.$tree)
            }
        })

        window.addEventListener("resize", () => {
            const blockid = this.$tree.getAttribute("block-id")
            const $drop = document.querySelector(`.z-select-dropdown[block-id=${blockid}]`)
            if($drop) {
                this.setPos($drop, this.$tree)
            }
        })
    }

    // 展开下拉
    openDrop() {
        const {$tree} = this
        $tree.classList.add("z-tree-open")
        const blockid = $tree.getAttribute("block-id")
        const $drop = document.querySelector(`.z-select-dropdown[block-id=${blockid}]`)
        if ($drop) {
            $drop.style.display = "block"
            $drop.classList.remove("fade-out")
            $drop.classList.add("fade-in")
        }
    }

    // 关闭下拉
    closeDrop() {
        const {$tree} = this
        $tree.classList.remove("z-tree-open")
        const blockid = $tree.getAttribute("block-id")
        const $drop = document.querySelector(`.z-select-dropdown[block-id=${blockid}]`)
        if ($drop) {
            $drop.classList.remove("fade-in")
            $drop.classList.add("fade-out")
            setTimeout(() => {
                if($tree.classList.contains("z-tree-open")) {return}
                $drop.style.display = "none"
            }, 400);
        }
    }

    // 更新目标下拉位置
    setPos(container, $el) {
        const _left_distance = $el.getBoundingClientRect().left
        const _top_distance = $el.getBoundingClientRect().top
        const _el_height = $el.getBoundingClientRect().height
        const _el_width = $el.getBoundingClientRect().width

        container.style.left = `${_left_distance}px`
        container.style.width = `${_el_width}px`
        container.style.top = `${_top_distance + _el_height}px`
    }

    // 创建dropdown
    creatDrop($el, menuData) {
        const container = document.createElement("div")
        container.className = "z-select-dropdown menu-tree"
        this.setPos(container, $el)
        container.style.display = `block`

        const _id = `drop__${Date.now()}`
        container.setAttribute("block-id", _id)
        $el.setAttribute("block-id", _id)
        $el.setAttribute("data-init", "inited")

        this.renderData(menuData, container)
        this.initTreeEvents(container, this.$tree)

        container.classList.add("fade-in")
        document.querySelector("body").appendChild(container)
    }

    // 渲染数据生成树形结构
    renderData(menuData, parentElement) {
        var ul = document.createElement('ul');
        ul.classList.add("z-menu__list")
        parentElement.appendChild(ul);

        const this_ = this
        menuData.forEach(function(menuItem) {
            var li = document.createElement('li');
            li.classList.add("z-menu-item")
            li.style.paddingLeft = '8px'
            let liInner = `<div class="z-menu-item__title ${menuItem.child && menuItem.child.length ? '':`z-menu-item__title_value`}" data-value="${menuItem.value}">
                            ${menuItem.child && menuItem.child.length ? `<svg class="z-submenu__arrow" viewBox="64 64 896 896" focusable="false" data-icon="down"
                        width="14px" height="14px" fill="currentColor" aria-hidden="true">
                        <path
                            d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z">
                        </path>
                    </svg>` : ''}<span>${menuItem.name}</span>
                        </div>`
            
            li.innerHTML = liInner
            ul.appendChild(li);

            if (menuItem.child && menuItem.child.length > 0) {
                this_.renderData(menuItem.child, li);
            }
        });
    }

    // 树状事件绑定
    initTreeEvents($el, $tree) {
        $($el).find('li > ul').each(function (i) {
            var parent_li = $(this).parent('li');

            var sub_ul = $(this).remove();
            parent_li.wrapInner('<a/>').find('a').click(function () {
                sub_ul.slideToggle(200)
                $(this).toggleClass('expanded');
            });
            parent_li.append(sub_ul);
        });
        $($el).find('ul ul').hide();

        // 选中
        const this_ = this
        $($el).find(".z-menu-item__title_value").click(function() {
            $($el).find(".z-menu-item__title_value").removeClass("active")
            const text = $(this).find("span").text() || ''
            this_.handleSelectValue($(this).attr("data-value"), text, $tree)
            $(this).addClass("active")
        })
    }

    // 选中值处理
    handleSelectValue(value, text, $tree) {
        $tree.querySelector(".z-tree-input").value = text
        $tree.querySelector(".z-tree-input").setAttribute("data-value", value)
        this.closeDrop()
    }

    // 点击其它区域关闭下拉
    outCloseDrop(e) {
        const $el = e.target
        const $parent = e.target.parentNode
        const blockid = this.$tree.getAttribute("block-id")
        const $drop = document.querySelector(`.z-select-dropdown[block-id=${blockid}]`)

        if ($el !== this.$tree && $parent !== this.$tree) {
            if($drop && $drop.contains($el)) {
                return false
            }
            this.$tree.classList.contains("z-tree-open") && this.closeDrop()
        }
    }

    // 清空
    handleReset() {
        const blockid = this.$tree.getAttribute("block-id")
        const $drop = document.querySelector(`.z-select-dropdown[block-id=${blockid}]`)
        if($drop) {
            $($drop).find(".z-menu-item__title_value").removeClass("active")
            this.$tree.querySelector(".z-tree-input").value = ""
            this.$tree.querySelector(".z-tree-input").setAttribute("data-value", "")
        }
        this.closeDrop()
    }
}

export default TreeSelect